import React, { useState } from 'react';
import { Box, Button, Typography, Snackbar, Alert } from '@mui/material';
import api from '../api';

export default function Settings() {
  const [message, setMessage] = useState<string | null>(null);
  const [error, setError] = useState<string | null>(null);

  const handleClose = () => {
    setMessage(null);
    setError(null);
  };

  const handleBackup = async () => {
    try {
      const res = await api.get('/customers/backup', {
        responseType: 'blob',
      });
      const url = window.URL.createObjectURL(new Blob([res.data]));
      const link = document.createElement('a');
      link.href = url;
      const now = new Date();
      const timestamp = now.toLocaleString('sv-SE').replace(/[: ]/g, '-'); // e.g., 2025-07-26-21-40-00
      const filename = `גיבוי_לקוחות_${timestamp}.json`;
      link.setAttribute('download', filename);

      document.body.appendChild(link);
      link.click();
      setMessage('הגיבוי בוצע בהצלחה');
    } catch (err: any) {
      if (err.response?.status === 403) {
        setError('אין הרשאה לגבות נתונים');
      } else {
        setError('פעולת הגיבוי נכשלה');
      }
    }
  };

  const handleRestore = async () => {
    const input = document.createElement('input');
    input.type = 'file';
    input.accept = '.json';
    input.onchange = async () => {
      const file = input.files?.[0];
      if (!file) return;

      const formData = new FormData();
      formData.append('file', file);

      try {
        await api.post('/customers/restore', formData);
        setMessage('השחזור בוצע בהצלחה');
      } catch (err: any) {
        if (err.response?.status === 403) {
          setError('אין הרשאה לשחזר נתונים');
        } else {
          setError('פעולת השחזור נכשלה');
        }
      }
    };
    input.click();
  };

  return (
    <Box>
      <Typography variant="h6" gutterBottom>הגדרות</Typography>
      <Button variant="contained" onClick={handleBackup} sx={{ mr: 2 }}>
        גיבוי
      </Button>
      <Button variant="contained" color="secondary" onClick={handleRestore}>
        שיחזור
      </Button>

      {/* ✅ Snackbar for success */}
<Snackbar
  open={!!message}
  autoHideDuration={4000}
  onClose={handleClose}
  anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
  sx={{
    top: '50% !important', // override MUI positioning
    transform: 'translateY(-50%)',
  }}
>
  <Alert onClose={handleClose} severity="success" sx={{ width: '100%' }}>
    {message}
  </Alert>
</Snackbar>

{/* ❌ Snackbar for error */}
<Snackbar
  open={!!error}
  autoHideDuration={4000}
  onClose={handleClose}
  anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
  sx={{
    top: '50% !important',
    transform: 'translateY(-50%)',
  }}
>
  <Alert onClose={handleClose} severity="error" sx={{ width: '100%' }}>
    {error}
  </Alert>
</Snackbar>

    </Box>
  );
}
